import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { PAGINATION_LIMIT } from "constants";

export default function PaginationCM(props) {
  return (
    <Stack spacing={2} mx="auto" my={4} mb={2}>
      <Pagination
        count={Math.ceil(props.count / (props.limit ?? PAGINATION_LIMIT))}
        page={props.page}
        onChange={props.handleChange}
        color="primary"
        style={{ margin: "auto" }}
        variant="outlined"
        shape="rounded"
      />
    </Stack>
  );
}
